import React from "react";
import { LeftSideBarCol } from "./LeftSideBarSpacing";

export interface SideBarProps {
  stepNumber: string;
  isNormalStep: boolean;
}

const LeftSideBar = ({ stepNumber, isNormalStep = true }: SideBarProps) => (
  <>
    <LeftSideBarCol className="items-center">
      <div className="flex flex-row items-stretch flex-1 flex-wrap h-full m-0">
        <div className="self-stretch flex-[1_0_100%] flex">
          <div className="border-r-0 w-1/2 pl-0 pr-0">
            <div />
          </div>
          <div className="border-l border-gray-10 w-1/2 pl-0 pr-0">
            <div />
          </div>
        </div>
        <div className="self-stretch flex-[1_0_100%] flex">
          <div className="flex-1 flex justify-center items-center pl-0 pr-0 m-0">
            <div className="w-10 h-10 bg-gradient-to-br from-white/100 to-white/0 shadow-[0px_6px_30px_-2px_rgba(0,0,0,0.12)] backdrop-blur rounded-full font-semibold text-base leading-6 text-black mt-3 mb-3 pl-0 pr-0 flex justify-center items-center">
              {stepNumber}
            </div>
          </div>
        </div>
        {isNormalStep && (
          <div className="self-stretch flex-[1_0_100%] flex">
            <div className="border-r-0 w-1/2 pl-0 pr-0">
              <div />
            </div>
            <div className="border-l border-gray-10 w-1/2 pl-0 pr-0">
              <div />
            </div>
          </div>
        )}
        {!isNormalStep && (
          <div className="self-stretch flex-[1_0_100%] flex">
            <div className="w-1/2 pl-0 pr-0 m-0">
              <div />
            </div>
            <div className="w-1/2 pl-0 pr-0 m-0">
              <div />
            </div>
          </div>
        )}
      </div>
    </LeftSideBarCol>
  </>
);
export default LeftSideBar;
